export const IS_ACTIVE: string = 'is-active'
export const IS_BAD: string = 'is-bad'
export const IS_DRAG: string = 'is-drag'
export const IS_FINAL: string = 'is-final'
export const IS_HIDDEN: string = 'is-hidden'
export const IS_LOADING: string = 'is-loading'
export const IS_REMOVING: string = 'is-removing'
